module.exports = __webpack_public_path__ + "static/media/scene.2dcee403.png";